function AuditReport() {
    return (
        <div>
            <h2>Audit Report</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default AuditReport;